import React from "react";
import Select from "react-select";
import vehicleImage from "../../assets/img/image 5.png";

const CustomerResVehicleInfo = () => (
    <div>
        <div className="min-h-0 flex-1 pb-[5rem]">
            <div>
                <div
                    className="text-[1.2rem] fontbold"
                    style={{
                        paddingBottom: "1.5rem",
                    }}>
                    Customer Reservation
                </div>
            </div>
            <form action="/action_page.php">
                <div className="container-style">
                    {/* Vehicle Information */}
                    <div className="vehicle-information">
                        <h1 className="information">Vehicle Information</h1>
                        <div className="border-style" />

                        <div
                            style={{
                                paddingTop: "20px",
                            }}>
                            <h1 className="name-style">Vehicle Type</h1>
                            <span
                                style={{
                                    color: "red",
                                    display: "inline-block",
                                }}>
                                *
                            </span>
                            <br />
                            <div>
                                <Select
                                    placeholder="Please Select"
                                    defaultValue={""}
                                    // onChange={(e) => {}}
                                    options={[
                                        {
                                            value: "discount",
                                            label: "discount",
                                        },
                                        {
                                            value: "discount",
                                            label: "discount",
                                        },
                                    ]}
                                    required
                                    // disabled={}
                                />
                            </div>
                        </div>
                        <div>
                            <h1 className="name-style">Rate</h1>
                            <span
                                style={{
                                    color: "red",
                                    display: "inline-block",
                                }}>
                                *
                            </span>
                            <br />
                            <input className="input-style" type="email" required />
                        </div>
                    </div>
                    {/* Vehicle Image */}
                    <div className="vehicle-image">
                        <h1 className="vehicle-name">Vehicle:</h1>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                            <img width="172.16px" height="108px" src={vehicleImage} alt="" />
                        </div>
                        <div
                            className="vehicle-trait"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "25px",
                            }}>
                            <div>
                                <h1 className="info-doors-people-lagg">
                                    Doors:
                                    <span
                                        style={{
                                            fontWeight: "bolder",
                                            paddingLeft: "1px",
                                        }}>
                                        5
                                    </span>
                                </h1>
                            </div>
                            <div className="border-left-style" />
                            <div>
                                <h1 className="info-doors-people-lagg">
                                    PEOPLE:{" "}
                                    <span
                                        style={{
                                            fontWeight: "bolder",
                                            paddingLeft: "1px",
                                        }}>
                                        8
                                    </span>
                                </h1>
                            </div>
                            <div className="border-left-style" />
                            <div>
                                <h1 className="info-doors-people-lagg">
                                    LUGGAGES:
                                    <span
                                        style={{
                                            fontWeight: "bolder",
                                            paddingLeft: "1px",
                                        }}>
                                        4
                                    </span>
                                </h1>
                            </div>
                        </div>
                    </div>

                    {/* Note's & Memo */}
                    <div className="others-information-note-memo">
                        <h1 className="information">Note&apos;s & Memo</h1>
                        <div className="border-style" />

                        <div
                            style={{
                                paddingTop: "20px",
                            }}>
                            <h1 className="name-style">Customer Note </h1>
                            <span
                                style={{
                                    color: "red",
                                    display: "inline-block",
                                }}>
                                *
                            </span>
                            <br />
                            <textarea className="customer-note1" type="text" required />
                        </div>
                        <div>
                            <h1 className="name-style">Memo</h1>
                            <span
                                style={{
                                    color: "red",
                                    display: "inline-block",
                                }}>
                                *
                            </span>
                            <br />
                            <textarea className="customer-note1" type="text" required />
                        </div>
                        <div>
                            <h1 className="name-style">Language</h1>
                            <span
                                style={{
                                    color: "red",
                                    display: "inline-block",
                                }}>
                                *
                            </span>
                            <br />
                            <div>
                                <Select
                                    placeholder="Select Language"
                                    defaultValue={""}
                                    // onChange={(e) => {}}
                                    options={[
                                        {
                                            value: "discount",
                                            label: "discount",
                                        },
                                        {
                                            value: "discount",
                                            label: "discount",
                                        },
                                    ]}
                                    required
                                    // disabled={}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            position: "relative",
                            paddingTop: "1rem",
                        }}>
                        <div
                            style={{
                                position: "absolute",

                                left: "255%",
                            }}>
                            <div>
                                <button className="submit-button" type="submit" value="Next">
                                    {<span className="next">Next</span>}
                                    &nbsp;
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.16675 10H15.8334"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M10 4.16675L15.8333 10.0001L10 15.8334"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div
                            style={{
                                position: "absolute",

                                left: "205%",
                            }}>
                            <button className="previous-button" type="submit" value="Next">
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.8335 10H4.16683"
                                        stroke="#5D5CFF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M10 15.8333L4.16667 9.99992L10 4.16658"
                                        stroke="#5D5CFF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                &nbsp;
                                {<span className="previous">Previous</span>}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
);

export default CustomerResVehicleInfo;
